import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PandabuySpreadsheetGuide from "../pages/article/pandabuy-spreadsheet-guide/page";
import PandabuySpreadsheetForBeginners from "../pages/article/pandabuy-spreadsheet-for-beginners/page";
import BestPandabuySpreadsheetFinds from "../pages/article/best-pandabuy-spreadsheet-finds-2026/page";
import PandabuySpreadsheetSafetyTips from "../pages/article/pandabuy-spreadsheet-safety-tips/page";
import PandabuySneakersSpreadsheet from "../pages/article/pandabuy-sneakers-spreadsheet/page";
import PandabuyClothingSpreadsheet from "../pages/article/pandabuy-clothing-spreadsheet/page";
import PandabuySpreadsheetShippingGuide from "../pages/article/pandabuy-spreadsheet-shipping-guide/page";
import PandabuyTrustedSellersGuide from "../pages/article/pandabuy-trusted-sellers-guide/page";
import PandabuyBudgetFinds from "../pages/article/pandabuy-budget-finds/page";
import PandabuySpreadsheetQCGuide from "../pages/article/pandabuy-spreadsheet-qc-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/pandabuy-spreadsheet-guide",
    element: <PandabuySpreadsheetGuide />,
  },
  {
    path: "/article/pandabuy-spreadsheet-for-beginners",
    element: <PandabuySpreadsheetForBeginners />,
  },
  {
    path: "/article/best-pandabuy-spreadsheet-finds-2026",
    element: <BestPandabuySpreadsheetFinds />,
  },
  {
    path: "/article/pandabuy-spreadsheet-safety-tips",
    element: <PandabuySpreadsheetSafetyTips />,
  },
  {
    path: "/article/pandabuy-sneakers-spreadsheet",
    element: <PandabuySneakersSpreadsheet />,
  },
  {
    path: "/article/pandabuy-clothing-spreadsheet",
    element: <PandabuyClothingSpreadsheet />,
  },
  {
    path: "/article/pandabuy-spreadsheet-shipping-guide",
    element: <PandabuySpreadsheetShippingGuide />,
  },
  {
    path: "/article/pandabuy-trusted-sellers-guide",
    element: <PandabuyTrustedSellersGuide />,
  },
  {
    path: "/article/pandabuy-budget-finds",
    element: <PandabuyBudgetFinds />,
  },
  {
    path: "/article/pandabuy-spreadsheet-qc-guide",
    element: <PandabuySpreadsheetQCGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;